<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-modal-back></app-modal-back>
    </ion-buttons>
    <ion-title> Last Minute job </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <mable-heading heading="h2">Cancel {{ accountService.userIs('carer') ? 'Booking' : 'Job' }}?</mable-heading>
  <p class="body-normal-16 ion-margin-horizontal">
    Things sometimes come up, especially in these difficult times. That’s why we are currently
    <span class="text-bold">waiving our normal cancellation penalty.</span>
  </p>
  <app-cancellation-policy buttonColor="grey-500"></app-cancellation-policy>
  <p class="body-normal-16 ion-margin-horizontal">
    To confirm the cancellation, message the {{ !accountService.userIs('carer') ? 'worker' : 'client' }} and let them
    know you can’t make it.
  </p>
</ion-content>
<ion-toolbar>
  <ion-grid>
    <ion-row>
      <ion-col [size]="!accountService.userIs('carer') || channelUrl ? '6' : '12'">
        <mable-button
          expand="block"
          category="outline"
          (onClick)="modalCtrl.dismiss()"
          >Back</mable-button
        >
      </ion-col>
      <ion-col
        size="6"
        *ngIf="!accountService.userIs('carer') || channelUrl"
      >
        <app-message-button
          [userId]="userId"
          [buttonText]="!accountService.userIs('carer') ? 'Message worker' : 'Message client'"
          [channelUrl]="channelUrl"
        ></app-message-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-toolbar>
